<template>
  <Page :title="title">
    <div class="clients360" ref="scrollView">
      <!-- 客户这个人信息展示 -->
      <div class="clients-information" style="min-height: 4.5rem;">
        <div class="clients-information-header">
          <img
            :src="basicList.custBasicInfo.headUrl?basicList.custBasicInfo.headUrl:basicList.custBasicInfo.sex==0?require('@/assets/MM.png'):require('@/assets/WW.png')"
            alt="" class="headerImg" srcset="">
          <!-- VIP -->
          <img class="vipImg" v-if="basicList.custBasicInfo.member=='10'" :src="require('@/assets/img/v.png')" alt="">
          <!--  姓名  电话 VIP登记 时间  -->
          <div class="information-list">
            <div class="clientName">
              {{ basicList.custBasicInfo.custName || '' }}
            </div>
            <div class="phone">
              <img :src="require('@/assets/img/phone.png')" class="phoneImg" alt="" srcset="">
              <div class="phone-numer">{{ this.$campKit.maskMobile(basicList.custBasicInfo.mobile || '') }}</div>
              <a :href="'tel:'+basicList.custBasicInfo.mobile" class="telPhoneA">
                <img :src="require('@/assets/telPhone.png')" class="telPhone" alt="">
              </a>
              <img :src="require('@/assets/img/contact.png')"
                   style="margin-left:  0.2rem;height: 0.5rem;width: 0.5rem"
                   v-if="userExId!=null  && userAdd"
                   alt @click="openUserProfile()" srcset>
            </div>
            <div class="Vip-flex">
              <div>VIP等级：</div>
              <div class="VIP-starts" :style="'width:'+VipNum*.4+'rem'">
                <img v-for="(item,index) in VipNum" v-bind:key="index" :src="require('@/assets/img/vipStar.png')"
                     class="start"
                     alt="" srcset="">
              </div>
              <div class="month" v-if="timeM!=''">（{{ timeM }}个月）</div>
            </div>
          </div>
        </div>

        <!--
                &lt;!&ndash; 标签栏 &ndash;&gt;
                <div class="label-list" v-if="tag_state=='open'">
                  <div v-for="(item,index)   in  label" :class="item.edit==false?'label-title':'label-title-active'" v-bind:key="index"
                    @click="addLabel(item.edit)">{{item.name}}</div>
                    <img class="tag_img" v-if="label.length>3" @click="tag_state_change" :src="require('@/assets/cust/tag_shrink.png')"  alt="" srcset="">
                </div>
                <div class="label-list" v-else>
                  <div v-for="(item,index)   in  label" v-if="index<3" :class="item.edit==false?'label-title':'label-title-active'" v-bind:key="index"
                    @click="addLabel(item.edit)">{{item.name}}</div>
                    <img class="tag_img" v-if="label.length>3" @click="tag_state_change" :src="require('@/assets/cust/tag_more.png')"  alt="" srcset="">
                </div>

                -->
      </div>
      <!-- 展示栏信息列表 -->
      <div class="clients-informationLists">
        <div class="messageList-header">
          <div v-for="(item,index)  in  messageList " class="messageList-item" v-bind:key="index"
               @click="tagMessageList(item)">
            <img :src="item.edit==false?item.img:item.imges" alt="">
            <div class="infos" v-if="item.code!=0">{{ item.code }}</div>
            <div>{{ item.name }}</div>
          </div>
        </div>
        <!-- 根据筛选  展示不能信息组件 -->
        <div>
          <basicIf :data="basicList" v-show="showTab=='basicIf'" :custId="this.custId" :hasModifyAuth="hasModifyAuth"
                   ref="basicIf"/>
          <Inproduct v-show="showTab=='Inproduct'" :custId="this.custId" ref="Inproduct"/>
          <ByProduct v-show="showTab=='ByProduct'" :custId="this.custId" ref="ByProduct"/>
          <FwNews v-show="showTab=='followIn'" :custId="this.custId" ref="FwNews"/>
          <JnActivity v-show="showTab=='activity'" :custId="this.custId" ref="JnActivity"/>
          <JnCurriculum v-show="showTab=='course'" :custId="this.custId" ref="JnCurriculum"/>
          <TheRecords v-show="showTab=='ecords'" :custId="this.custId" ref="TheRecords"/>
          <repairHis v-show="showTab=='repairHis'" :custId="this.custId" ref="repairHis"/>
          <TagSetUp v-show="showTab=='TagSetUp'" :custId="this.custId" :isshow="showTab == 'TagSetUp' "/>
        </div>
        <div class="">
          <div class="basic-information">
            <div class="basic-information-title">外部人信息</div>
            <div class="redactImg"></div>
          </div>
          <div class="basic-information-flex">
            {{ externalContact }}
          </div>
        </div>
        <!-- 最近信息  系统信息 -->
        <div style="display: none;">
          <!-- 基本信息 -->
          <div class="basic-information">
            <div class="basic-information-title">最近信息</div>
            <div class="redactImg"></div>
          </div>
          <div class="basic-information-flex" v-if="basicList.latelyInfo">
            <ul class="basic-information-lists">
              <li>
                <div class="basic-information-lists-item">消费门店</div>
                <div class="basic-information-lists-text">{{ basicList.latelyInfo.deptName || '' }}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">购买时间</div>
                <div class="basic-information-lists-text">{{ basicList.latelyInfo.buyDate || '' }}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">参与活动</div>
                <div class="basic-information-lists-text">{{ basicList.latelyInfo.campName || '' }}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">参与课程</div>
                <div class="basic-information-lists-text">{{ basicList.latelyInfo.courseName || '' }}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">消费金额</div>
                <div class="basic-information-lists-text">
                  {{ basicList.latelyInfo.amount ? $numeral(basicList.latelyInfo.amount).format('0,0.00') : "" }}
                </div>
              </li>
              <li>
                <div class="basic-information-lists-item">联系日期</div>
                <div class="basic-information-lists-text">
                  {{ basicList.latelyInfo.followDate ? basicList.latelyInfo.followDate.split(" ")[0] : '' }}
                </div>
              </li>
            </ul>
          </div>

          <div class="basic-information">
            <div class="basic-information-title">系统信息</div>
            <div class="redactImg"></div>
          </div>
          <div class="basic-information-flex" v-if="basicList.systemInfo">
            <ul class="basic-information-lists">
              <li>
                <div class="basic-information-lists-item">销售顾问</div>
                <div class="basic-information-lists-text">{{ basicList.systemInfo.createUserName || '' }}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">所属门店</div>
                <div class="basic-information-lists-text">{{ basicList.systemInfo.createDeptName || '' }}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">修改人</div>
                <div class="basic-information-lists-text">{{ basicList.systemInfo.modifyUserName || '' }}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">修改门店</div>
                <div class="basic-information-lists-text">{{ basicList.systemInfo.modifyDeptName || '' }}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">创建时间</div>
                <div class="basic-information-lists-text">
                  {{ basicList.systemInfo.createTime ? basicList.systemInfo.createTime : '' }}
                </div>
              </li>
              <li>
                <div class="basic-information-lists-item">最近修改时间</div>
                <div class="basic-information-lists-text">
                  {{ basicList.systemInfo.modifyTime ? basicList.systemInfo.modifyTime : '' }}
                </div>
              </li>
            </ul>
          </div>

        </div>

      </div>
      <!-- 弹出层 -->
      <van-popup v-model="labelShow">
        <div class="label-models">
          <!-- 标题  -->
          <div class="label-model-title">
            <div class="label-model-titles">选择客户标签</div>
            <div class="select-label-hint">提示：单击选择，再次点击取消。</div>
          </div>
          <div class="label-list-flex-itemAuto">
            <div v-for="(items,index) in selectLabel" v-bind:key="index">
              <!-- 标题 -->
              <div class="basic-label-title">{{ items.typeName }}</div>
              <!-- 标签展示内容列表 -->
              <div class="label-list-flex-item">
                <div class="label-list-flex">
                  <div v-for="(item,index) in items.tagList" v-bind:key="index" class="select-labels-title"
                       @click="clickLabels(index,item)"
                       :style="'background:'+item.background">{{ item.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 确定取消 -->
          <div class="confirm-cancel">
            <div class="button-flex-color flex-border-button">
              <div class="button-flex-item" @click="cancelLabel">取消</div>
            </div>
            <div class="button-flex-color">
              <div class="button-flex-item button-active" @click="confirmLabel">确定</div>
            </div>
          </div>
        </div>
      </van-popup>


      <!-- 弹出层 新增客户 -->
      <van-popup :close-on-click-overlay="false" v-model="addClient">
        <div class="add-model">
          <!-- 标题 -->
          <div class="addClientTitle">新增客户</div>
          <!-- 区号  手机号号码 -->
          <div class="codePhone">
            <div class="codeArea">
              <div class="codeAreaInput" :class="{'readonly':addClientObj.readonly}" @click="pickerClient('add')">
                {{ addClientObj.code }}
              </div>
            </div>
            <div class="input-flex" :class="{'readonly':addClientObj.readonly}">
              <input type="number" :readonly="addClientObj.readonly"
                     oninput="if(value.length>30)value=value.slice(0,30)"
                     @blur="phoneCS(addClientObj.phone)" v-model="addClientObj.phone" placeholder="请输入手机号码">
            </div>
          </div>
          <!-- 请输入客户姓名 -->
          <div class="client-name">
            <div class="client-name-flex">
              <input type="text" oninput="if(value.length>100)value=value.slice(0,100)" class="client-name-input"
                     v-model="addClientObj.name" placeholder="请输入客户姓名">
            </div>
          </div>
          <!--  单选项  -->
          <div class="genderRadio-flex">
            <van-radio-group v-model="addClientObj.sex">
              <van-radio name="1"> 男
                <img slot="icon" slot-scope="props" :src="props.checked ? Icon[0]: Icon[1]" class="radioImg">
              </van-radio>
              <van-radio name="2"> 女
                <img slot="icon" slot-scope="props" :src="props.checked ? Icon[0]: Icon[1]" class="radioImg">
              </van-radio>
            </van-radio-group>
          </div>
          <!-- 确定 取消 -->
          <div class="confirm-cancel">
            <div class="button-flex-color flex-border-button">
              <div class="button-flex-item" @click="addCL">取消</div>
            </div>
            <div class="button-flex-color">
              <div class="button-flex-item button-active" @click="addCF">确定</div>
            </div>
          </div>
        </div>

      </van-popup>

      <!-- 弹出层 搜索客户 -->
      <van-popup :close-on-click-overlay="false" v-model="searchClient">
        <div class="van-popup-box">
          <!-- 标题 -->
          <div class="van-popup-title">
            <img :src="require('@/assets/img/tip.png')" alt="">
            搜索客户
          </div>
          <div class="van-popup-content">
            <div class="msg">
              未查询出该客户的360信息<br/>
              请尝试输入手机号查询
            </div>
            <!-- 区号  手机号号码 -->
            <div class="codePhone">
              <div class="codeArea">
                <div class="codeAreaInput" @click="pickerClient('search')">{{ searchClientObj.code }}</div>
              </div>
              <div class="input-flex">
                <input type="number" oninput="if(value.length>30)value=value.slice(0,30)"
                       v-model="searchClientObj.phone"
                       placeholder="请输入手机号码">
              </div>
            </div>
          </div>
          <div class="van-popup-btn">
            <!-- 确定 取消 -->
            <div class="confirm-cancel">
              <div class="button-flex-color flex-border-button">
                <div class="button-flex-item" @click="cacalSearch">取消</div>
              </div>
              <div class="button-flex-color">
                <div class="button-flex-item button-active" @click="submitSearch">确定</div>
              </div>
            </div>
          </div>
        </div>
      </van-popup>
      <!-- 区号筛选 -->
      <van-popup v-model="showAreaCode" position="bottom" :overlay="true">
        <van-picker show-toolbar title="" :columns="columnsCode" @cancel="onCancelCode" @confirm="onConfirmCode"
                    value-key="name" class="van-picker-li"/>
      </van-popup>
    </div>
  </Page>
</template>


<script>
import basicIf from "./childCompoents/basicInfo360.vue"; //基本信息
import Inproduct from "./childCompoents/IntentionProduct.vue"; //意向产品
import ByProduct from "./childCompoents/haveProduct.vue"; //购买产品
import FwNews from "./childCompoents/followNews.vue"; //跟进信息
import JnActivity from "./childCompoents/joinActivity.vue"; //参与活动
import JnCurriculum from "./childCompoents/joinCurriculum.vue" //参与课程
import TheRecords from "./childCompoents/theRecords.vue" //问卷记录
import repairHis from "./childCompoents/repairHis.vue" //问卷记录
import TagSetUp from "./childCompoents/tagSetUp.vue" //标签设置
import campKit from "@/common/campKit.js";
import {
  differenceInMonths
} from 'date-fns';
import {Dialog} from "vant";

export default {
  data() {
    return {
      title: "客户360",
      VipNum: 0, //VIP 等级
      listIndex: 0,
      externalContact: '',
      custId: "", //客户ID
      tag_state: "shrink",
      extUserId: 'wmFEqSDgAAcVbfKAgqFCkBJfPO61l5wg', //'wmhuh1DAAAp3Wv5uzseaA_AOPEn9_YPA',
      label: [], // 标签列表
      selectLabel: [
        // 选择标签列表
        {
          name: "微信会员",
          edit: false,
          background: "#373737"
        },
        {
          name: "入门基础课程",
          edit: false,
          background: "#373737"
        },
      ],
      labelShow: false, // 标签展示
      showTab: 'basicIf',
      messageList: [{
        name: "基本信息",
        img: require("@/assets/course/information.png"),
        imges: require("@/assets/course/information1.png"),
        edit: true,
        val: 1,
        code: 0,
        key: 'basicIf'
      },
        {
          name: "拥有产品",
          img: require("@/assets/course/ByProduct.png"),
          imges: require("@/assets/course/ByProduct1.png"),
          val: 2,
          edit: false,
          code: 0,
          key: 'ByProduct'
        },
        {
          name: "意向产品",
          img: require("@/assets/course/InProduct.png"),
          imges: require("@/assets/course/InProduct1.png"),
          val: 3,
          edit: false,
          code: 0,
          key: 'Inproduct'
        },

        {
          name: "跟进信息",
          img: require("@/assets/course/followIn.png"),
          imges: require("@/assets/course/followIn1.png"),
          val: 4,
          edit: false,
          code: 0,
          key: 'followIn'
        },
        {
          name: "参与活动",
          img: require("@/assets/course/activity.png"),
          imges: require("@/assets/course/activity1.png"),
          val: 5,
          edit: false,
          code: 0,
          key: 'activity'
        },
        {
          name: "参与课程",
          img: require("@/assets/course/course.png"),
          imges: require("@/assets/course/course1.png"),
          val: 6,
          code: 0,
          edit: false,
          key: 'course'
        },
        {
          name: "维修记录",
          img: require("@/assets/cust/repairHis.png"),
          imges: require("@/assets/cust/repairHisSelected.png"),
          val: 7,
          edit: false,
          code: 0,
          key: 'repairHis'
        }
      ],
      // 基本信息
      basicList: {
        custBasicInfo: {}, //基本信息
        systemInfo: {}, //系统新
        latelyInfo: {}, //最近信息
        assetList: [], //相机集合
      },
      pitchList: [], // 选中列表
      pitchLists: [], // 选后 选中列表存在选项
      deleteList: [], // 删除列表
      timeM: "", // 入会员月份
      IdCode: "", // 客户菜单ID
      hasModifyAuth: true, //是否有修改客户的权限

      searchClient: false, //搜索客户弹出框
      customer: {},
      userExId: null,
      userAdd: false,
      //新增客户相关
      U_AreaCode: [], //区号
      showAreaCode: false, //是否显示区号选择器
      columnsCode: ['+86', '其他'], // 筛选区号
      Icon: [require('@/assets/Sc.png'), require('@/assets/Sn.png')],
      addClient: false, //新增客户
      addClientObj: {
        phone: "", //手机号码
        name: "", //姓名
        sex: '1', //性别
        code: "+86", //区号
        codeValue: "86", //默认code
        readonly: false //phone只读
      },
      searchClientObj: { // 手机号搜索客户
        phone: "", //手机号码
        code: "+86", //区号
        codeValue: "86", //默认code
      },
    };
  },
  methods: {


    /**
     *  添加标签
     *  @param {Boolean}  val
     */
    addLabel(val) {
      if (val) {
        this.labelShow = true;
        this.getTagAlls();
      }
    },
    /**
     *
     *  获取code
     *  @param {String} tcode
     *
     */
    getQueryByTcode(){
      this.$api.getQueryByTcode({tcode:'U_AreaCode'}).then(Response=>{
        console.log("获取区号",Response)
        if(Response.success){
          this.U_AreaCode=Response.data;
        }else{
          this.$title(Response.msg);
        }
      })
    },
    tag_state_change() {
      if (this.tag_state == 'open') {
        this.tag_state = 'shrink';
      } else {
        this.tag_state = 'open';
      }
    },
    /**
     *  单机点击标签
     *  @param {Number}  index
     *  @param {Boolean}  val
     **/
    clickLabels(index, val) {
      let $list = [];
      $list = this.selectLabel;
      if (val.edit) {
        $list[val.index]['tagList'][index]["edit"] = false;
        $list[val.index]['tagList'][index]["background"] = "#373737";
        this.selectLabel = $list;
        let $index_ = this.pitchLists.indexOf(val.id);
        this.pitchLists.splice($index_, 1)
      } else {
        $list[val.index]['tagList'][index]["edit"] = true;
        $list[val.index]['tagList'][index]["background"] = "#E51C23";
        this.selectLabel = $list;
        this.pitchLists.push(val.id);
      }
    },
    /**
     *   确定取消
     *
     **/

    cancelLabel() {
      let $list = [];
      $list = this.selectLabel;
      for (let i = 0; i < $list.length; i++) {
        $list[i]["edit"] = false;
        $list[i]["background"] = "#373737";
      }
      this.selectLabel = $list;
      this.labelShow = false;
      this.pitchLists = [];
      this.pitchList = [];
    },
    confirmLabel() {
      let $list = [],
        $activeLabel = [],
        $delete = []

      /***
       *  对比已选中的数组  和提交的数组  已删除的数组选项
       */
      for (let k = 0; k < this.selectLabel.length; k++) {
        let $tag = this.selectLabel[k]['tagList'];
        if ($tag) {
          for (let g = 0; g < $tag.length; g++) {
            if ($tag[g]['type'] == 1 && $tag[g]['edit'] == false) {
              $delete.push($tag[g]['id'])
            }
            if ($tag[g]['edit'] == true) {
              $activeLabel.push($tag[g]['id'])
            }
          }
        }
      }
      this.setSaveTag($delete.join(","), $activeLabel.join(","))
    },

    tagMessageList(item) {
      /**
       * basicIf
       ByProduct
       InProduct
       followIn
       activity
       course
       records
       repairHis
       TagSetUp
       */
      for (let i = 0; i < this.messageList.length; i++) {
        if (this.messageList[i]['key'] == item.key) {
          this.messageList[i]['edit'] = true;
        } else {
          this.messageList[i]['edit'] = false;
        }
      }
      this.showTab = item.key;
      if (this.custId == '' || this.custId == null)
        return;
      switch (item.key) {
        case 'basicIf':
          this.$refs.basicIf.getCustId(this.custId);
          break
        case 'ByProduct':
          this.$refs.ByProduct.getCustListSoldProd(this.custId);
          break
        case 'Inproduct':
          this.$refs.Inproduct.custListIntentionProd(this.custId);
          break
        case 'followIn':
          this.$refs.FwNews.getCustListFollow(this.custId);
          break
        case 'activity':
          this.$refs.JnActivity.joinActivityList(this.custId);
          break
        case 'course':
          this.$refs.JnCurriculum.joinCurriculumList(this.custId);
          break
        case 'records':
          this.$refs.TheRecords.getCustListSurvey(this.custId);
          break
        case 'repairHis':
          this.$refs.repairHis.queryList(this.custId);
          break
        case 'TagSetUp':
          break
      }
    },
    /**
     *
     *
     *  客户详情接口
     *  @param {String}  salesId
     *  @param {String}  custId
     *
     */
    getCustDetail(custId) {
      this.getTagListCust();
      this.$api.getCustDetail({
        salesId: this.$wxuserUtil.getUserId(),
        custId: custId
      }).then(Response => {
        if (Response.success == true) {
          this.userExId = Response.data.userExId;
          this.userAdd = Response.data.userAdd;
          this.basicList['custBasicInfo'] = Response.data.custBasicInfo || {}; //基本信息
          this.basicList['latelyInfo'] = Response.data.latelyInfo || {}; //最近信息
          this.basicList['systemInfo'] = Response.data.systemInfo || {}; //系统信息
          this.basicList['assetList'] = Response.data.custBasicInfo || []; //相机列表
          this.updateTitleNum(Response.data.relaCnt)
          var date = new Date();
          var year = date.getFullYear();
          var month = date.getMonth();
          var day = date.getDay();
          if (Response.data.custBasicInfo.vipLevel) {
            this.VipNum = Response.data.custBasicInfo.vipLevel ? parseInt(Response.data.custBasicInfo.vipLevel /
              10) : 0
          }
          if (Response.data.custBasicInfo.registerDate) {
            var s1 = Response.data.custBasicInfo.registerDate.split(" ")[0].replace(/-/g, "/");
            var s2 = "";
            s1 = new Date(s1.replace(/-/g, "/"));
            s2 = new Date(); //当前日期：2017-04-24
            var days = s2.getTime() - s1.getTime();
            var time = parseInt(days / (1000 * 60 * 60 * 24)) / 30;
            this.timeM = parseInt(time) ? parseInt(time) : parseInt(time) < 30 ? 1 : '';
          }
        } else {
          this.timeM = "";
        }
        try {
          this.$refs.basicIf.getCustId(custId);
          this.$refs.JnCurriculum.joinCurriculumList(custId);
          this.$refs.TheRecords.getCustListSurvey(custId);
          this.$refs.JnActivity.joinActivityList(custId);
          this.$refs.Inproduct.custListIntentionProd(custId);
          this.$refs.FwNews.getCustListFollow(custId);
          this.$refs.ByProduct.getCustListSoldProd(custId);
        } catch (e) {
        }
      })
    },
    /**
     *  打开个人信息页接口
     *
     * */
    openUserProfile() {

      wx.invoke('openEnterpriseChat', {
        "externalUserIds": this.userExId,
        "groupName": "",
        "chatId": "",
        fail: function (res) {
          if (res.err_msg != "openUserProfile:ok") {
            //错误处理
            Dialog.alert({
              message: res.err_msg,
            }).then(() => {
              // on close
            });
          }
        }
      })
    },
    /**
     *
     * 更新标题栏数量展示
     *
     */
    updateTitleNum(DATA) {
      console.log("传入的数组1", DATA)
      if (typeof DATA == "object") {

        this.messageList[2]['code'] = DATA['leadCnt'] //意向产品
        this.messageList[1]['code'] = DATA['purchaseRecordCnt'] //购买产品/拥有产品
        this.messageList[3]['code'] = DATA['followCnt'] //跟进信息
        this.messageList[4]['code'] = DATA['campaignCnt'] //活动次数
        this.messageList[5]['code'] = DATA['courseCnt'] //课程数
        // this.messageList[6]['code']=DATA['surveyCnt']//问卷调查数
        this.messageList[6]['code'] = DATA['repairHisCnt'] //维修次数
      }
    },
    /**
     *
     *
     * 客户全部标签
     *
     */
    getTagAlls() {
      this.$api.getTagAlls({
        salesId: this.$wxuserUtil.getUserId()
      }).then(Response => {
        this.selectLabel = this.setLabelEdit(2, Response.data)
        this.showLabelEdit();
      })
    },
    /**
     *
     *
     * 客户标签列表
     *
     */
    getTagListCust(ID) {
      this.$api.getTagListCustPost({
        salesId: this.$wxuserUtil.getUserId(),
        custId: this.custId
      }).then(Response => {
        this.label = this.setLabelEdit(1, Response.data);
        // if (ID) {
        //   this.label = this.setLabelEdit(1, Response.data)
        // } else {
        //   this.label = this.setLabelEdit(1, Response.data).concat([{
        //     name: "＋",
        //     edit: true
        //   }])
        // }
      })
    },
    /**
     *
     *
     *  客户标签更新
     *
     */
    setSaveTag(delTag, addTag) {
      this.$loading();
      this.$api.setSaveTag({
        salesId: this.$wxuserUtil.getUserId(),
        custId: this.custId,
        delTag: delTag,
        addTag: addTag,
      }).then(Response => {
        if (Response.success == true) {
          this.getTagListCust();
          this.$clear("更新成功");
        } else {
          this.$title("更新失败");
        }
        this.labelShow = false;
      })
    },
    /**
     *
     *  追加标签判断依据
     *
     */
    setLabelEdit(ID, DATA) {
      if (Array.isArray(DATA)) {
        for (let i = 0; i < DATA.length; i++) {
          if (DATA[i]) {
            if (ID == 1) {
              DATA['edit'] = false;
            }
            if (ID == 2) {
              let $tagList = DATA[i]['tagList'];
              for (let o = 0; o < $tagList.length; o++) {
                $tagList[o]['edit'] = false;
                $tagList[o]['index'] = i;
                $tagList[o]['background'] = "#373737";
                $tagList[o]['type'] = 0;
              }
            }
          }
        }
        return DATA;
      } else {
        return [];
      }
    },
    /**
     *
     *   初始化标签样式展示
     */
    showLabelEdit(DATA) {
      let $list_ = [],
        $list_All = [],
        $pitchList = [];
      $list_ = this.label; //标签列表
      $list_All = this.selectLabel; //全部标签
      for (let i = 0; i < $list_All.length; i++) {
        let $tag = $list_All[i]['tagList'];
        if ($tag) {
          for (let o = 0; o < $tag.length; o++) {
            for (let k = 0; k < $list_.length; k++) {
              if ($tag[o]['id'] == $list_[k]['tagId']) {
                this.pitchList.push($list_[k]['tagId']);
                this.pitchLists.push($list_[k]['tagId']);
                $tag[o]['edit'] = true;
                $tag[o]['background'] = '#E51C23';
                $tag[o]['type'] = 1;
              } else {

              }
            }
          }
        }
      }
      this.selectLabel = $list_All;
    },

    pickerClient(code) {
      this.showCodes = code;
      switch (code) {
        case 'add':
          if (this.addClientObj.readonly)
            return;
          this.columnsCode = this.U_AreaCode;
          break
        case 'search':
          this.columnsCode = this.U_AreaCode;
          break
      }
      this.showAreaCode = true;
    },
    /**
     *   区号弹出框确认事件
     */
    onConfirmCode(value, index) {
      console.log(value, index)
      let code = this.showCodes;
      let codeValue = value.value;
      switch (code) {
        case 'add':
          this.addClientObj.code = value.name;
          this.addClientObj.codeValue = codeValue;
          break
        case 'search':
          this.searchClientObj.code = value.name;
          this.searchClientObj.codeValue = codeValue;
          break;
      }
      console.log(this.searchClientObj);
      this.showAreaCode = false;
    },
    /**
     *   区号弹出框取消事件
     */
    onCancelCode() {
      this.showAreaCode = false;
    },
    /**
     *   搜索弹出框取消事件
     */
    cacalSearch() {
      this.searchClient = false;
      this.closeWindow();
    },
    /**
     * 搜索弹出框确认事件
     */
    submitSearch() {
      let that = this;
      //debugger;
      if (!this.searchClientObj.phone)
        return;
      //this.$refs.inputText.blur();
      this.$api.getCustValidatorMobile({
        mobile: this.searchClientObj.phone,
        salesId: this.$wxuserUtil.getUserId(),
        extUid: this.extUserId,
        update: 1,
      }).then(Response => {
        console.log('根据手机号搜索:', Response);
        if (Response.success) { //查询成功则说明没有客户，去弹框新增客户
          that.addClient = true;
          that.searchClient = false;
          that.addClientObj = {
            phone: that.searchClientObj.phone,
            name: "", //姓名
            sex: '1', //性别
            code: that.searchClientObj.code, //区号
            codeValue: that.searchClientObj.codeValue, //默认code
            readonly: true
          }
        } else {
          if (Response.data) { //存在数据则有客户
            that.custId = Response.data.custId;
            that.getCustDetail(Response.data.custId);
            that.searchClient = false;
          } else { //其他情况弹出错误
            this.$title(Response.msg);
          }
        }

      })
    },
    /**
     *  取消新增客户
     */
    addCL() {
      this.addClient = false
      this.addClientObj = {
        code: "+86", //区号
        phone: "", //手机号码
        name: "", //姓名
        sex: '1', //性别
        codeValue: '86',
      }
      this.closeWindow();
    },
    /**
     * 确认新增客户
     */
    addCF() {
      let data = {
        salesId: this.$wxuserUtil.getUserId(),
        mobile: this.addClientObj.phone,
        custName: this.addClientObj.name,
        gender: this.addClientObj.sex == 1 ? 0 : 1,
        areaCode: this.addClientObj.codeValue,
        extUid: this.extUserId,
      }
      console.log(this.addClientObj);
      if (this.addClientObj.phone == "") {
        this.$title("请输入手机号码");
        return;
      }
      if (this.addClientObj.name == "") {
        this.$title("请输入客户姓名");
        return;
      }
      console.log("新增客户数据", data);
      this.saveCustAdd(data)
    },
    //手机号验证
    phoneCS(val) {
      console.log("失去焦点", val)
      let phone = "";
      if (this.addClientObj.codeValue == "86") {
        phone = val
      } else {
        phone = val
      }
      this.getCustValidatorMobile(phone)
    },
    /**
     * 跟进外部id 查询是否有客户信息
     *
     */
    getClientByExtUserId(extUserId) {
      let that = this;
      let postData = {
        salesId: this.$wxuserUtil.getUserId(),
        extUid: extUserId,
      }
      this.$api.getClientByExtUserId(postData).then(Response => {
        if (Response.success) {
          that.custId = Response.data.custId;
          that.getCustDetail(that.custId);
        } else {
          if (Response.code == '404') {//弹出手机号搜索框框
            that.searchClient = true;
          } else {
            this.$title(Response.msg);
          }
        }
      })
    },
    /**
     * 手机号码验证
     */
    getCustValidatorMobile(Phone) {
      //this.$refs.inputText.blur();
      this.$api.getCustValidatorMobile({
        mobile: Phone,
        salesId: this.$wxuserUtil.getUserId(),
      }).then(Response => {
        if (Response.data) {
          if (Response.data.custId) {
            this.$dialog.confirm({
              title: '提示',
              message: `客户已存在-${Response.data.deptName}门店`,
              confirmButtonText: "确定"
            }).then(() => {
            }).catch(() => {
              this.addClient = false;
              this.addCL();
            });
          }
        }
      })
    },

    /**
     * 新增客户接口
     */
    saveCustAdd(data) {
      console.log('新增客户', data);
      let that = this;
      this.$api.saveCustAdd(data).then(Response => {
        if (Response.success) {
          this.$title("新增客户成功");
          setTimeout(() => {
            that.addClient = false;
            that.custId = Response.data.custId;
            that.getCustDetail(Response.data.custId);
          }, 500);
        } else {
          this.$title(Response.msg);
        }
      })
    },
    fun() {
      this.$router.replace('/client360');
      console.log("监听到了");
    },
    /**
     * 关闭当前页面
     */
    closeWindow() {
      if (typeof wx.closeWindow != 'undefined') {
        wx.closeWindow();
      } else {
        window.location.href = "about:blank";
        window.close();
      }
    }
  },
  mounted() {
    let that = this;


    if (window.history && window.history.pushState) { //监听返回
      history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.fun, false); //false阻止默认事件
    }
    this.hasModifyAuth = this.$wxuserUtil.hasFunAuthByRouteInst(this.$route, this.$funcKey.BasicModified);

    //开发用的，uat、线上版本 都需要去掉
    // that.getClientByExtUserId(that.extUserId);


      //加载获取外部联系人
      this.$wxuserUtil.initWxAgentSdk().then(
        function(data) {
          console.log(data);
          that.$wxuserUtil.getCurExternalContact(
            function(response) {
              that.externalContact = response;
              that.extUserId = response;
              that.getClientByExtUserId(response);
            },
            function(err) {
              console.log(err);
              this.$title('获取外部联系人信息失败');
            }
          );
        }
      ).catch((err) => console.log(err)); //捕获异常;

 1

    this.$refs.scrollView.style.height = localStorage.getItem('height') + 'px';
    let $route_ = this.$route;
    if ($route_.query.custId) {
      this.custId = $route_.query.custId;
      this.getCustDetail($route_.query.custId);
      if ($route_.query.showID != undefined) {
        this.listIndex = $route_.query.showID;
        this.showMessageList(this.listIndex)
        if (this.listIndex == 1) {
          this.$refs.Inproduct.redact(1)
        }
        if (this.listIndex == 2) {

          if ($route_.query.value == 'qrcode') {
            this.$refs.ByProduct.scanQR()
          } else {
            this.$refs.ByProduct.redact(1)
          }
        }
        if (this.listIndex == 3) {
          this.$refs.FwNews.redact(1)
        }

      }
      // 判断是否有权限
      if ($route_.query.showCC != undefined) {
        let Bl_ = false;
        if ($route_.query.showCC == "false" || $route_.query.showCC == false) {
          Bl_ = false;
        } else {
          Bl_ = true;
        }
        this.$refs.basicIf.authority(!Bl_)
        this.$refs.Inproduct.authority(!Bl_)
        this.$refs.ByProduct.authority(!Bl_)
        this.$refs.FwNews.authority(!Bl_)
        if (Bl_ == false) {
          this.getTagListCust()
        } else {
          this.getTagListCust(1);
        }
      }
      //跳转选项卡
      if ($route_.query.index != undefined && $route_.query.index >= 0 && $route_.query.index <= 7) {
        this.showMessageList($route_.query.index);
      }

    } else {
      //this.addClient=true;
      //this.$title("客户ID为空");

    }
    this.IdCode = this.$route.query.IdCode;


    let obj = this.$wxuserUtil.getUserObj();

    if (obj.deptType == 5 || obj.deptType == 7 || obj.U_AddTag == 1) {

      let item = {
        name: "标签信息",
        img: require("@/assets/cust/tag.png"),
        imges: require("@/assets/cust/tag1.png"),
        val: 8,
        edit: false,
        code: 0,
        key: 'TagSetUp'
      };

      this.messageList.push(item);
      this.getQueryByTcode();
    }


  },

  watch: {},
  created() {
    this.$campKit = campKit;
  },
  components: {
    basicIf,
    Inproduct,
    ByProduct,
    FwNews,
    JnActivity,
    JnCurriculum,
    TheRecords,
    repairHis,
    TagSetUp
  },
  destroyed() {
    window.removeEventListener('popstate', this.fun, false); //false阻止默认事件
  },
};
</script>

<style lang="less" src="~p/pageView-client360.less" scoped></style>
<style lang="less" scoped="true" src="~p/pageView-client.less"></style>



// WEBPACK FOOTER //
// src/components/client/client360.vue